import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import formatName from 'I18n/utils/formatName';
import SystemMessage from '../system-message/SystemMessage';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { getEmailSubject, getTimestamp, getWorkflowId, getRecipientVid
// @ts-expect-error module not typed
} from 'conversations-message-history/crm-object-workflow-email-sent/operators/crmObjectWorkflowEmailSentGetters';
// @ts-expect-error module not typed
import { getVerboseDateText } from 'conversations-message-history/util/getVerboseDateText';
import WorkflowLink from './WorkflowLink';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { EmailThreadedRepliesIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectWorkflowEmailSentMessage = ({
  message,
  portalId,
  senders,
  vid,
  visitorRecipients
}) => {
  const recipientVid = getRecipientVid(message);
  const recipientVidString = recipientVid ? recipientVid.toString() : '';
  const visitorRecipient = visitorRecipients && visitorRecipients[recipientVidString];
  const visitorSender = findSender(vid, VISITOR, senders);
  const recipient = (visitorRecipient === null || visitorRecipient === void 0 ? void 0 : visitorRecipient.data) || visitorRecipient || (visitorSender === null || visitorSender === void 0 ? void 0 : visitorSender.data);
  const finalRecipient = recipient !== null && recipient !== void 0 && recipient.toJS ? recipient.toJS() : recipient;
  const {
    firstName,
    lastName,
    email
  } = finalRecipient || {};
  const recipientName = recipient ? formatName({
    firstName,
    lastName,
    email
  }) : /*#__PURE__*/_jsx(SkeletonText, {
    inlineSize: "200px"
  });
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.thread-crm-object-workflow-email-sent.default",
      options: {
        date: getVerboseDateText(getTimestamp(message)),
        emailSubjectWithWorkflowLink: /*#__PURE__*/_jsx(WorkflowLink, {
          portalId: portalId,
          workflowId: getWorkflowId(message),
          emailSubject: getEmailSubject(message)
        }),
        visitorName: recipientName
      }
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: EmailThreadedRepliesIcon,
      size: "500"
    })
  });
};
CrmObjectWorkflowEmailSentMessage.displayName = 'CrmObjectWorkflowEmailSentMessage';
export default CrmObjectWorkflowEmailSentMessage;